const UserState = {
    auth: {},
    user: {},
    userProfile: {},
    users: { data: [] },
    nextOfKins: { data: [] },
};

export default UserState;